import { useMemo } from "react";
import { Link } from "react-router-dom";
import { MobileCloseIcon, MobileLogoIcon, ShortLogoIcon } from "./ui-icons/header";
import { MobileMenuIcon } from "./ui-icons/menu";
import Avatar from "./ui/avatar";
import { useMenu } from "../contexts/MenuContext";
import { HomeIcon } from "./ui-icons/menu";
import { NavSection } from "./NavSection";
import { twMerge } from "tailwind-merge";
import { getSafeAreaTopPaddingCss } from "src/utils/mobile";

const homeNavigationItems = [{ name: "Главная", url: "/", icon: <HomeIcon /> }];

// const mobileNavigations = [
//   { name: "Написать в тех. поддержку", url: "/support", icon: <HeadphonesIcon /> },
//   { name: "Оставить обратную связь", url: "/callback", icon: <CallbackIcon /> }
// ];

// Мобильная версия: скрываем пункты "Написать в тех. поддержку" и "Оставить обратную связь"
const mobileNavigations: any[] = [];

export default function MobileHeader() {
  const { isMenuOpen, toggleMenu, closeMenu } = useMenu();
  const headerPaddingTop = useMemo(() => getSafeAreaTopPaddingCss(20), []);
  const menuPaddingTop = useMemo(() => getSafeAreaTopPaddingCss(68), []);

  const openCloseMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    toggleMenu();
  };

  return (
    <>
      <header
        className="relative z-20 flex flex-row items-center justify-between pb-5"
        style={{ paddingTop: headerPaddingTop }}
      >
        <div className="sm:container px-10 max-md:px-6 sm:mx-auto w-full">
          <div className="flex flex-row items-center justify-between max-sm:flex-row-reverse">
            <div className="flex flex-col items-center justify-center config">
              <div className="flex flex-row">
                <button className="flex" onClick={openCloseMenu}>
                  {isMenuOpen ? <MobileCloseIcon /> : <MobileMenuIcon />}
                </button>
              </div>
            </div>
            <div className="flex flex-col logo">
              <Link to="/" onClick={closeMenu}>
                {isMenuOpen ? <ShortLogoIcon /> : <MobileLogoIcon />}
              </Link>
            </div>

            <Avatar />
          </div>
        </div>
      </header>
      <div
        className={twMerge(
          isMenuOpen ? "translate-x-0 hidden-body-scroll" : "-translate-x-full",
          "fixed mobile-menu z-10 top-0 left-0 w-full h-full bg-white transform transition-transform duration-300"
        )}
      >
        <div
          className="container px-10 max-md:px-7.5 mx-auto text-[14px] text-[#637381]"
          style={{ paddingTop: menuPaddingTop }}
        >
          <div className="flex flex-col divide-y">
            <NavSection links={homeNavigationItems} />
            {mobileNavigations.length > 0 && <NavSection links={mobileNavigations} />}
          </div>
        </div>
      </div>
    </>
  );
}
